import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  slideRight: {
    isOpen: false,
    title: '',
    content: null,
  },
  slideUp: {
    isOpen: false,
    title: '',
    description: '',
    buttons: [],
    buttonStyle: {},
  },
  alert: {
    isOpen: false,
    title: '',
    description: '',
    buttons: [],
    buttonStyle: {},
  },
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openSlideRight: (state, action) => {
      state.slideRight = {
        ...state.slideRight,
        isOpen: true,
        ...action.payload,
      };
    },
    closeSlideRight: state => {
      state.slideRight = initialState.slideRight;
    },
    openSlideUp: (state, action) => {
      state.slideUp = {
        ...state.slideUp,
        isOpen: true,
        ...action.payload,
      };
    },
    closeSlideUp: state => {
      state.slideUp = initialState.slideUp;
    },

    openAlert: (state, action) => {
      state.alert = {
        ...state.alert,
        isOpen: true,
        ...action.payload,
      };
    },
    closeAlert: state => {
      state.alert = initialState.alert;
    },
  },
});

export const {
  openSlideRight,
  closeSlideRight,
  openSlideUp,
  closeSlideUp,

  openAlert,
  closeAlert,
} = dialogSlice.actions;
export default dialogSlice.reducer;
